import React from 'react';
import { theme } from '../../styles/theme';

interface CardProps {
  children: React.ReactNode;
  style?: React.CSSProperties;
}

export function Card({ children, style }: CardProps) {
  return (
    <div style={{
      background: theme.colors.card,
      borderRadius: theme.borderRadius['3xl'],
      border: `1px solid ${theme.colors.borderLight}`,
      boxShadow: theme.shadows.card,
      maxHeight: '100%',
      overflowY: 'auto',
      ...style,
    }}>
      {children}
    </div>
  );
}
